export default __webpack_public_path__ + "ac6b809.png";